import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import {
  insertShift,
  getShift,
  getCategorys,
  deleteShift,
  getCompanys,
  getDepartments,
  getShifttype
} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import jsPDF from "jspdf";
import Select from "react-select";
import { getSecureItem } from "../../services/SecureStorage";
export default function Shift() {
  const UID = getSecureItem("userId");
  const [uFetch, setUfetch] = useState({
    UserId: UID,
  });
  const [addShiftModal, setAddShiftModal] = useState(false);
  const [editShiftModal, setEditShiftModal] = useState(false);
  const [shifts, setShifts] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [categorys, setCategorys] = useState([]);
  const [Department, setDepartment] = useState([]);
  const [shifttype, setShiftType] = useState([])
  const [typeofshift, setTYypeofshift] = useState([])

  const [loading, setLoading] = useState(false);
  const [companyDetails, setCompanyDetails] = useState([])

  const [shiftData, setShiftData] = useState({
    Name: "",
    Narration: "",
    StartTime: "",
    EndTime: "",
    MinOverTime: "",
    MinWorkingHour: "",
    DepartmentId: [],
    WorkingHour: "",
    MaxWorkingHour: "",
    HalfDay: "",
    GracePeriod: "",
    Remarks: "",
    UserId: UID,
    allowHalfday: true,
    HalfDayStartTimeMorning: "",
    HalfDayEndTimeMorning: "",
    WorkingHourMorningHalfDay: "",
    HalfDayStartTimeEvening: "",
    HalfDayEndTimeEvening: "",
    WorkingHourEveningHalfDay: "",
    shiftallownace: "",
    typeofshift: "",
    startDate: "",     // e.g. "2025-03-15"
    endDate: "",     // e.g. "2025-03-20"
    shiftDeduction: "",

  });

  function convertTimeToHourMinuteFormat(time) {
    if (!time) {
      return "00:00";
    }

    const date = new Date(time);
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();

    // Format hours and minutes to ensure two digits
    const formattedHours = String(hours).padStart(2, "0"); // Use padStart for zero-padding
    const formattedMinutes = String(minutes).padStart(2, "0"); // Use padStart for zero-padding

    return `${formattedHours}:${formattedMinutes}`;
  }



  const openAddShiftModal = () => {
    setShiftData({
      Name: "",
      Narration: "",
      StartTime: "",
      EndTime: "",
      MinOverTime: "",
      MinWorkingHour: "",
      MaxWorkingHour: "",
      HalfDay: "",
      GracePeriod: "",
      Remarks: "",
      UserId: UID,
      allowHalfday: true,
      HalfDayStartTimeMorning: "",
      HalfDayEndTimeMorning: "",
      WorkingHourMorningHalfDay: "",
      HalfDayStartTimeEvening: "",
      HalfDayEndTimeEvening: "",
      WorkingHourEveningHalfDay: "",
      typeofshift: "",
      startDate: "",
      shiftallownace: "",
      endDate: "",
      shiftDeduction: "",
    });
    setAddShiftModal(!addShiftModal);
  };
  const openEditShiftModal = (data) => {
    console.log(data, 'ssssssss');

    // Helper function to format time into "Xh Ym"
    function convertTimeToHourMinuteFormat(time) {
      const date = new Date(time);
      const hours = date.getUTCHours();
      const minutes = date.getUTCMinutes();
      return `${hours}h ${minutes}m`;
    }

    // Find DepartmentName (optional, as it's not used in the Select component)
    const DepartmentName = Department?.find((item) => item.Id === data?.DepartmentIds);

    // Convert DepartmentId string to an array
    const departmentIds = data?.DepartmentIds ? data.DepartmentIds.split(",") : [];

    // Find CategoryName (if needed)
    const CategoryName = categorys.find((item) => item.Id === data?.CategoryId);

    setShiftData({
      ...data,
      CategoryId: data?.CategoryId,
      DepartmentId: departmentIds, // Set as an array
      Department: DepartmentName?.Name || "", // Optional, if used elsewhere
      CategoryName: CategoryName?.Name || "", // Default to empty string if not found
      UserId: UID || "", // Ensure UserId is defined

    });

    setEditShiftModal(!editShiftModal);
  };

  const fetchDepartment = async () => {
    setLoading(true)
    try {
      const res = await getDepartments(UID)
      setDepartment(res.data.data)
    } catch {
      setLoading(false)
    }
  }


  const fetchShiftsTypes = async () => {
    setLoading(true)
    try {
      const res = await getShifttype(UID);
      const updated = res.data.data.map((el) => ({
        ...el,
        TypeName: el.TypeName === "Long Day Shift" ? "Unlimitted shift" : el.TypeName
      }));
      setShiftType(updated);
    } catch {
      setLoading(false)
    }
  }


  useEffect(() => {
    setLoading(true);
    fetchShifts();
    fetchDepartment()
    fetchShiftsTypes()
  }, []);

  useEffect(() => {
    if (shifts && shifts.length > 0) {
      const updatedData = shifts.map((item, index) => ({
        Slno: index + 1,
        Id: item.Id || "",
        Name: item.Name || "",
        Narration: item.Narration || "",
        StartTime: item.StartTime || "",
        EndTime: item.EndTime || "",
        MinOverTime: item.MinOverTime || "",
        HalfDay: item.HalfDay || "",
        MinWorkingHour: item.MinWorkingHour || "",
        MaxWorkingHour: item.MaxWorkingHour || "",
        GracePeriod: item.GracePeriod || "",
        Remarks: item.Remarks || "",
        DepartmentIds: item.DepartmentId || "",
        UserId: UID,
        allowHalfday: item.allowHalfday,
        HalfDayStartTimeMorning: item.HalfDayStartTimeMorning,
        HalfDayEndTimeMorning: item.HalfDayEndTimeMorning,
        WorkingHourMorningHalfDay: item.WorkingHourMorningHalfDay,
        HalfDayStartTimeEvening: item.HalfDayStartTimeEvening,
        HalfDayEndTimeEvening: item.HalfDayEndTimeEvening,
        WorkingHourEveningHalfDay: item.WorkingHourEveningHalfDay,
        endDate: item.endDate,
        startDate: item.startDate,
        typeofshift: item.typeofshift,
        shiftallownace: item.shiftallownace,
        shiftDeduction: item.shiftDeduction,
        // DepartmentId: item.DepartmentId || ,"",
      }));
      setDataFilter(updatedData);
    } else {
      setDataFilter([]);
    }
  }, [shifts]);

  const fetchShifts = async () => {
    setLoading(true);
    try {
      const data = await getShift(UID);
      const formattedShifts = data.data.data.map((shift) => {
        const convertedEndTime = convertTimeToHourMinuteFormat(shift.EndTime);
        const convertedStartTime = convertTimeToHourMinuteFormat(shift.StartTime);
        const convertedMaxWorkingHour = convertTimeToHourMinuteFormat(shift.MaxWorkingHour);
        const convertedMinOverTime = convertTimeToHourMinuteFormat(shift.MinOverTime);
        const convertedMinWorkingHour = convertTimeToHourMinuteFormat(shift.MinWorkingHour);
        const convertedHalfDay = convertTimeToHourMinuteFormat(shift.HalfDay);
        const convertedSTMH = convertTimeToHourMinuteFormat(shift.HalfDayStartTimeMorning);
        const convertedETMH = convertTimeToHourMinuteFormat(shift.HalfDayEndTimeMorning);
        const convertedWHMH = convertTimeToHourMinuteFormat(shift.WorkingHourMorningHalfDay);
        const convertedSTEH = convertTimeToHourMinuteFormat(shift.HalfDayStartTimeEvening);
        const convertedETEH = convertTimeToHourMinuteFormat(shift.HalfDayEndTimeEvening);
        const convertedWHEH = convertTimeToHourMinuteFormat(shift.WorkingHourEveningHalfDay);

        return {
          ...shift,
          EndTime: convertedEndTime,
          StartTime: convertedStartTime,
          MaxWorkingHour: convertedMaxWorkingHour,
          MinOverTime: convertedMinOverTime,
          MinWorkingHour: convertedMinWorkingHour,
          HalfDay: convertedHalfDay,
          HalfDayStartTimeMorning: convertedSTMH,
          HalfDayEndTimeMorning: convertedETMH,
          WorkingHourMorningHalfDay: convertedWHMH,
          HalfDayStartTimeEvening: convertedSTEH,
          HalfDayEndTimeEvening: convertedETEH,
          WorkingHourEveningHalfDay: convertedWHEH,

        };
      });

      setShifts(formattedShifts);
      setIsFilterVisible(false);
    } catch (error) {
      console.error("Error fetching shifts", error);
    }
    setLoading(false);
  };



  const isLongDayShift =
    shiftData.typeofshift &&
    shifttype.find(t => t.Id === shiftData.typeofshift)?.TypeName === "Unlimitted shift";
  const isNightShift =
    shiftData.typeofshift &&
    shifttype.find(t => t.Id === shiftData.typeofshift)?.TypeName === "Night Shift";

const calculateTimeDifference = (startStr, endStr) => {
  if (!startStr || !endStr) return "";

  // Handle "24:00" → treat as "00:00" next day if needed
  const normalizeTime = (time) => (time === "24:00" ? "00:00" : time);

  const [startH, startM] = normalizeTime(startStr).split(":").map(Number);
  const [endH,   endM]   = normalizeTime(endStr).split(":").map(Number);

  let startMinutes = startH * 60 + startM;
  let endMinutes   = endH * 60 + endM;

  // Handle overnight shift (end time is before start time → next day)
  if (endMinutes < startMinutes) {
    endMinutes += 24 * 60;
  }

  const diffMinutes = endMinutes - startMinutes;

  // Invalid or zero/negative duration
  if (diffMinutes <= 0 || diffMinutes >= 24 * 60) {
    return ""; // or you can return "Invalid"
  }

  const hours = Math.floor(diffMinutes / 60);
  const minutes = diffMinutes % 60;

  // Special case: exactly 24 hours
  if (hours === 24 && minutes === 0) {
    return "24:00";
  }

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};

 const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  setShiftData((prev) => {
    // 1. Apply the current input change first
    const updated = {
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    };

    // 2. Only recalculate half-day hours if one of the relevant fields changed
    if (
      name === "HalfDayStartTimeMorning" ||
      name === "HalfDayEndTimeMorning" ||
      name === "HalfDayStartTimeEvening" ||
      name === "HalfDayEndTimeEvening"
    ) {
      // Morning calculation
      if (updated.HalfDayStartTimeMorning && updated.HalfDayEndTimeMorning) {
        updated.WorkingHourMorningHalfDay = calculateTimeDifference(
          updated.HalfDayStartTimeMorning,
          updated.HalfDayEndTimeMorning
        );
      } else {
        updated.WorkingHourMorningHalfDay = "";
      }

      // Evening calculation
      if (updated.HalfDayStartTimeEvening && updated.HalfDayEndTimeEvening) {
        updated.WorkingHourEveningHalfDay = calculateTimeDifference(
          updated.HalfDayStartTimeEvening,
          updated.HalfDayEndTimeEvening
        );
      } else {
        updated.WorkingHourEveningHalfDay = "";
      }
    }

    // 3. Handle shift type change (your existing logic)
    if (name === "typeofshift") {
      const selectedType = shifttype.find((t) => t.Id === value);

      if (selectedType?.TypeName === "Unlimitted shift") {
        updated.StartTime = "";
        updated.EndTime = "";
        // Optional: clear half-day fields too if needed
        // updated.allowHalfday = false;
        // updated.HalfDayStartTimeMorning = "";
        // ...
      } else {
        updated.startDate = "";
        updated.endDate = "";
      }
    }

    return updated;
  });
};



  const handleBlur = () => {
    const parseTime = (time) => {
      const [hours, minutes] = time.split(":").map(Number);
      return hours * 60 + minutes; // Convert to total minutes
    };

    const isValidTimeFormat = (time) => {
      // Allow 00:00 to 23:59 and 24:00
      const timeRegex = /^((([01][0-9])|(2[0-3])):[0-5][0-9])|(24:00)$/;
      return timeRegex.test(time);
    };

    const { MinWorkingHour, MaxWorkingHour, WorkingHour, MinOverTime, HalfDay } = shiftData;
    let minError = "",
      maxError = "",
      minOverTimeError = "",
      halfDayError = "";

    // Validate MinWorkingHour format
    if (MinWorkingHour && !isValidTimeFormat(MinWorkingHour)) {
      minError = "Enter time in HH:MM format (e.g., 03:15).";
    } else if (
      WorkingHour &&
      MinWorkingHour &&
      parseTime(MinWorkingHour) > parseTime(WorkingHour)
    ) {
      minError = "Min Working Hour must be less than or equal to Working Hour.";
    }

    // Validate MaxWorkingHour format
    if (MaxWorkingHour && !isValidTimeFormat(MaxWorkingHour)) {
      maxError = "Enter time in HH:MM format (e.g., 03:15).";
    } else if (
      WorkingHour &&
      MaxWorkingHour &&
      parseTime(MaxWorkingHour) < parseTime(WorkingHour)
    ) {
      maxError = "Max Working Hour must be greater than or equal to Working Hour.";
    }

    // Validate MinOverTime format
    if (MinOverTime && !isValidTimeFormat(MinOverTime)) {
      minOverTimeError = "Enter time in HH:MM format (e.g., 03:15).";
    }

    // Validate HalfDay format
    if (HalfDay && !isValidTimeFormat(HalfDay)) {
      halfDayError = "Enter time in HH:MM format (e.g., 03:15).";
    } else if (
      WorkingHour &&
      HalfDay &&
      parseTime(HalfDay) > parseTime(WorkingHour)
    ) {
      halfDayError = "Half Day must be less than or equal to Working Hour.";
    }

    setShiftData((prev) => ({
      ...prev,
      MinWorkingHourError: minError,
      MaxWorkingHourError: maxError,
      MinOverTimeError: minOverTimeError,
      HalfDayError: halfDayError,
    }));
  };

  const [maxMwh, setMaxMwh] = useState(Boolean);
  const [minimumMwh, setMinimumMwh] = useState(Boolean);
  const [minOt, setMinOt] = useState(Boolean);

  // MinWorkingHour
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const timeFormatRegex = /^\d{2}:\d{2}$/;

      if (timeFormatRegex.test(shiftData?.MaxWorkingHour)) {
        setMaxMwh(true);
      } else {
        setMaxMwh(false);
      }

      if (timeFormatRegex.test(shiftData?.MinWorkingHour)) {
        setMinimumMwh(true);
      } else {
        setMinimumMwh(false);
      }

      if (timeFormatRegex.test(shiftData?.MinOverTime)) {
        setMinOt(true);
      } else {
        setMinOt(false);
      }

      console.debug("shiftData", shiftData);

      const today = new Date();
      const dateString = today.toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format

      // Handle 24:00 case for StartTime and EndTime
      const startTime = shiftData.StartTime === "24:00" ? "23:59:59.999" : shiftData.StartTime;
      const endTime = shiftData.EndTime === "24:00" ? "23:59:59.999" : shiftData.EndTime;

      const start = new Date(`${dateString}T${startTime}:00Z`);
      const end = new Date(`${dateString}T${endTime}:00Z`);

      // Adjust for 24:00 by adding 1 millisecond to make it a full day
      if (shiftData.EndTime === "24:00") {
        end.setTime(end.getTime() + 1);
      }
      if (shiftData.StartTime === "24:00") {
        start.setTime(start.getTime() + 1);
      }

      const workingTime = end - start;

      const hours = Math.floor(workingTime / (1000 * 60 * 60));
      const minutes = Math.floor((workingTime % (1000 * 60 * 60)) / (1000 * 60));

      // Special case for 24 hours
      let worktimeFormat;
      if (hours === 24 && minutes === 0) {
        worktimeFormat = "24:00";
      } else {
        worktimeFormat = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
      }

      console.debug("workingTime", worktimeFormat);

      // Handle 24:00 case for Min/MaxWorkingHour
      const minWH = shiftData.MinWorkingHour === "24:00" ? "23:59:59.999" : shiftData.MinWorkingHour;
      const maxWH = shiftData.MaxWorkingHour === "24:00" ? "23:59:59.999" : shiftData.MaxWorkingHour;

      const wroktimeMs = worktimeFormat === "24:00"
        ? 24 * 60 * 60 * 1000
        : new Date(`${dateString}T${worktimeFormat}:00Z`).getTime();

      const minimumWorkTimeMs = shiftData.MinWorkingHour === "24:00"
        ? 24 * 60 * 60 * 1000
        : new Date(`${dateString}T${minWH}:00Z`).getTime();

      const maximumWorkTimeMs = shiftData.MaxWorkingHour === "24:00"
        ? 24 * 60 * 60 * 1000
        : new Date(`${dateString}T${maxWH}:00Z`).getTime();

      setLoading(true);
      const response = await insertShift({
        ...shiftData,
        // Pass the original values (including 24:00) to the API
        StartTime: shiftData.StartTime,
        EndTime: shiftData.EndTime,
        MinWorkingHour: shiftData.MinWorkingHour,
        MaxWorkingHour: shiftData.MaxWorkingHour
      });

      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchShifts();
        openAddShiftModal();
      }
    } catch (error) {
      toast.error("Something went wrong, please try again");
      console.error("Error adding shift:", error);
    }
    setLoading(false);
  };

  // edit
  const handleEdit = async (e) => {
    e.preventDefault();


    try {
      const timeFormatRegex = /^\d{2}:\d{2}$/;

      if (timeFormatRegex.test(shiftData?.MaxWorkingHour)) {
        setMaxMwh(true);
      } else {
        setMaxMwh(false);
      }

      if (timeFormatRegex.test(shiftData?.MinWorkingHour)) {
        setMinimumMwh(true);
      } else {
        setMinimumMwh(false);
      }

      if (timeFormatRegex.test(shiftData?.MinOverTime)) {
        setMinOt(true);
      } else {
        setMinOt(false);
      }

      console.debug("shiftData", shiftData);

      const today = new Date();
      const dateString = today.toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format

      // Handle 24:00 case for StartTime and EndTime
      const startTime = shiftData.StartTime === "24:00" ? "23:59:59.999" : shiftData.StartTime;
      const endTime = shiftData.EndTime === "24:00" ? "23:59:59.999" : shiftData.EndTime;

      const start = new Date(`${dateString}T${startTime}:00Z`);
      const end = new Date(`${dateString}T${endTime}:00Z`);

      // Adjust for 24:00 by adding 1 millisecond to make it a full day
      if (shiftData.EndTime === "24:00") {
        end.setTime(end.getTime() + 1);
      }
      if (shiftData.StartTime === "24:00") {
        start.setTime(start.getTime() + 1);
      }

      const workingTime = end - start;

      const hours = Math.floor(workingTime / (1000 * 60 * 60));
      const minutes = Math.floor((workingTime % (1000 * 60 * 60)) / (1000 * 60));

      // Special case for 24 hours
      let worktimeFormat;
      if (hours === 24 && minutes === 0) {
        worktimeFormat = "24:00";
      } else {
        worktimeFormat = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
      }

      console.debug("workingTime", worktimeFormat);

      // Handle 24:00 case for Min/MaxWorkingHour
      const minWH = shiftData.MinWorkingHour === "24:00" ? "23:59:59.999" : shiftData.MinWorkingHour;
      const maxWH = shiftData.MaxWorkingHour === "24:00" ? "23:59:59.999" : shiftData.MaxWorkingHour;

      const wroktimeMs = worktimeFormat === "24:00"
        ? 24 * 60 * 60 * 1000
        : new Date(`${dateString}T${worktimeFormat}:00Z`).getTime();

      const minimumWorkTimeMs = shiftData.MinWorkingHour === "24:00"
        ? 24 * 60 * 60 * 1000
        : new Date(`${dateString}T${minWH}:00Z`).getTime();

      const maximumWorkTimeMs = shiftData.MaxWorkingHour === "24:00"
        ? 24 * 60 * 60 * 1000
        : new Date(`${dateString}T${maxWH}:00Z`).getTime();

      setLoading(true);
      const response = await insertShift({
        ...shiftData,
        // Pass the original values (including 24:00) to the API
        StartTime: shiftData.StartTime,
        EndTime: shiftData.EndTime,
        MinWorkingHour: shiftData.MinWorkingHour,
        MaxWorkingHour: shiftData.MaxWorkingHour
      });

      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchShifts();
        openEditShiftModal();
      }
    } catch (error) {
      toast.error("Something went wrong, please try again");
      console.error("Error editing shift:", error);
    } finally {
      setLoading(false);
    }
  };


  const departementOption = Department?.map((el) => ({
    value: el.Id,
    label: el.Name,
  }));
  const handleMultiSelectChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : [];
    setShiftData((prevState) => ({
      ...prevState,
      DepartmentId: selectedValues, // Store as an array
    }));
  };

  // Category fetch
  useEffect(() => {
    const fetchCategorys = async () => {
      try {
        const response = await getCategorys(UID);


        setCategorys(response.data.data);
      } catch (error) {
        console.error("Error fetching Categorys:", error);
      }
    };

    fetchCategorys();
  }, []);


  const clearData = () => {
    setShiftData({
      Name: "",
      Narration: "",
      StartTime: "",
      EndTime: "",
      MinOverTime: "",
      MinWorkingHour: "",
      MaxWorkingHour: "",
      HalfDay: "",
      GracePeriod: "",
      Remarks: "",
      UserId: UID,
      typeofshift: "",
      startDate: "",
      endDate: "",
      shiftallownace: ""
    });
  };

  const clearDataForEdit = () => {
    setShiftData((ref) => ({
      ...ref, // Spread the previous state
      Name: "",
      Narration: "",
      StartTime: "",
      EndTime: "",
      MinOverTime: "",
      MinWorkingHour: "",
      HalfDay: "",
      MaxWorkingHour: "",
      GracePeriod: "",
      Remarks: "",
      UserId: UID,
      typeofshift: "",
      startDate: "",
      endDate: "",
      shiftallownace: ""
    }));
  };

  const [deleteShiftTypeId, setDeleteShiftTypeId] = useState(null); // Correct naming convention
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (payScaleId) => {
    setDeleteShiftTypeId(payScaleId);
    setIsModalOpen(true);
  };

  // Close the modal and reset the state
  const closeModal = () => {
    setIsModalOpen(false);
    setDeleteShiftTypeId(null);
  };

  // Trigger the delete operation and close the modal
  const confirmDelete = () => {
    if (deleteShiftTypeId) {
      handleDelete(deleteShiftTypeId); // Ensure handleDelete is defined correctly
    }
    closeModal();
  };

  const handleDelete = async (shiftId) => {
    const removeData = { Id: shiftId, TableName: "Shift" };
    try {
      const res = await deleteShift(removeData, UID);
      if (res && res.data) {
        // Ensure the response has the expected structure
        if (res.status === 200 && res.data.message === "Deleted Successfully") {
          toast.success("Shift deleted successfully");
          fetchShifts(); // Refresh the list
        } else {
          toast.error(
            res.data.message || "Unexpected response from the server."
          );
        }
      } else {
        toast.error("Error deleting Shift");
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Shift.";
        toast.error("Shift already using cannot delete");
      } else {
        console.error("Error removing Shift:", error);
        toast.error("Error deleting Shift. Please try again.");
      }
    }
  };
  //


  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Shift Name",
      selector: (row) => row.Name,
      sortable: true,
      width: "350px",
    },
    {
      name: "Start Time",
      selector: (row) => row.StartTime || "",
      sortable: true,
    },
    {
      name: "End Time",
      selector: (row) => row.EndTime || "",
      sortable: true,
    },

    {
      name: "Min Over Time",
      selector: (row) => row.MinOverTime || "",
      sortable: true,
    },
    {
      name: "Min Working Hour",
      selector: (row) =>


        row.MinWorkingHour == "00:00" ? "24:00" :
          row.MinWorkingHour
      ,
      sortable: true,
    },


    {
      name: "Max Working Hour",
      selector: (row) =>
        row.MaxWorkingHour == "00:00" ? "24:00" :
          row.MaxWorkingHour,
      sortable: true,
    },
    {
      name: "Grace Period",
      selector: (row) => row.GracePeriod || "",
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditShiftModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];


  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const filteredItems = dataFilter.filter(
    (item) =>
      // item.Id.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Name.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Code?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Narration?.toLowerCase().includes(filterText.toLowerCase())
  );


  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanys(UID);
      setCompanyDetails(response.data.data[0]);
      console.log(response.data.data[0], 'Response Data');
    } catch (error) {
      console.error('An error occurred:', error);
      toast.error('An error occurred while fetching company details');
    }
  };

  useEffect(() => {
    fetchCompanyDetails();
  }, []);

  const downloadPdf = () => {
    console.log(companyDetails, 'Generating PDF...');

    const doc = new jsPDF();

    // Centered heading
    const pageWidth = doc.internal.pageSize.getWidth();
    const heading = `Shift Details ON ${companyDetails?.Name || 'Company'}`;
    const textWidth = doc.getTextWidth(heading);
    const xOffset = (pageWidth - textWidth) / 2;
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text(heading, xOffset, 10);

    // Table Head
    const tableHead = [["Sl No", "Shift Name", "Start Time", "End Time", "Grace Period"]];

    // Table Body from filteredItems
    const tableBody = filteredItems.map((item) => [
      item.Slno || "",
      item.Name || "",
      item.StartTime || "",
      item.EndTime || "",
      item.GracePeriod || "",
    ]);

    // Table styling with black borders and white background
    doc.autoTable({
      head: tableHead,
      body: tableBody,
      startY: 20,
      theme: 'grid',
      headStyles: {
        fillColor: [255, 255, 255], // White background for header
        textColor: [0, 0, 0], // Black text
        lineWidth: 0.2, // Black border width
        lineColor: [0, 0, 0], // Black border color
        fontStyle: 'bold',
        halign: 'center', // Center header text
      },
      bodyStyles: {
        fillColor: [255, 255, 255], // White background for rows
        textColor: [0, 0, 0], // Black text
        lineWidth: 0.2, // Black border width
        lineColor: [0, 0, 0], // Black border color
        halign: 'center', // Center body text
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255], // Ensure alternate rows are also white
      },
      margin: { top: 20 },
      styles: {
        font: 'helvetica',
        fontSize: 10,
        cellPadding: 2,
      },
    });

    doc.save("ShiftDetails.pdf");
  };




  const subHeaderComponentMemo = useMemo(() => {

  }, [filterText, resetPaginationToggle]);

  const formatTimee = (time) => {
    // Split the input time into hours and minutes
    const [hours, minutes] = time.split(":");

    // Pad hours and minutes with leading zeros if necessary
    const formattedHours = hours?.padStart(2, "0");
    const formattedMinutes = minutes?.padStart(2, "0");

    // Return the formatted time as HH:MM
    return `${formattedHours}:${formattedMinutes}`;
  };
  useEffect(() => {
    const calculateWorkingHours = () => {
      const { StartTime, EndTime } = shiftData;

      if (StartTime && EndTime) {
        // Special case for 24-hour shift
        if (StartTime === "00:00" && EndTime === "00:00") {
          setShiftData(prev => ({
            ...prev,
            WorkingHour: "24:00",
            MinWorkingHour: "24:00",
            MaxWorkingHour: "24:00"
          }));
          return;
        }

        const today = new Date();
        const dateString = today.toISOString().split('T')[0];
        const start = new Date(`${dateString}T${StartTime}:00`);
        const end = new Date(`${dateString}T${EndTime}:00`);

        // Handle overnight shifts
        if (end <= start) {
          end.setDate(end.getDate() + 1);
        }

        const diff = end - start;
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        setShiftData(prev => ({
          ...prev,
          WorkingHour: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`,
        }));
      } else {
        setShiftData(prev => ({ ...prev, WorkingHour: '' }));
      }
    };

    calculateWorkingHours();
  }, [shiftData.StartTime, shiftData.EndTime]);


  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };


  useEffect(() => {
    console.log(dataFilter, 'dasdasd');

  }, [dataFilter])

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  
  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Shift?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Shift" />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by Shift"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={openAddShiftModal}
            className="btn btn-primary"
          >
            Add New
          </button>
          <button
            onClick={downloadPdf}
            className="btn btn-danger"
          >
            PDF
          </button>
        </div>
      </div>


      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={shifts} onFilter={handleFilter} />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">

        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>
      {addShiftModal && (
        <form onSubmit={handleSubmit}>
          <div className="fixed inset-0 flex z-40 bg-black/40 backdrop-blur-sm  items-center justify-center z-[60] bg-black/30">
            <div className="w-full max-w-[700px] bg-bg-dark rounded-lg shadow-light p-6 md:p-10 flex flex-col max-h-[92vh] overflow-auto">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-4 py-8 mb-6 text-center border-b border-border">
                Add Shift
                <button
                  type="button"
                  onClick={openAddShiftModal}
                  className="absolute top-4 right-6 text-gray-400 hover:text-white"
                >
                  ✖
                </button>
              </h5>

              <div className="px-4 md:px-10 py-6 space-y-8">

                {/* Always visible fields */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="form-group">
                    <label>Shift Name <span className="text-red-500">*</span></label>
                    <input
                      type="text"
                      name="Name"
                      value={shiftData.Name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Shift Type <span className="text-red-500">*</span></label>
                    <select
                      name="typeofshift"
                      value={shiftData.typeofshift || ""}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select shift type</option>
                      {shifttype?.map((g) => (
                        <option key={g.Id} value={g.Id}>
                          {g.TypeName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* ─────────────────────────────────────────────── */}
                {/* LONG DAY / UNLIMITED SHIFT → very minimal fields */}
                {/* ─────────────────────────────────────────────── */}
                {isLongDayShift ? (
                  <div className="space-y-6 border-t border-gray-700 pt-6">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <div className="form-group">
                        <label>Shift Allowance</label>
                        <input
                          type="number"
                          name="shiftallownace"
                          value={shiftData.shiftallownace || ""}
                          onChange={handleChange}
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>

                      <div className="form-group">
                        <label>Shift Deduction</label>
                        <input
                          type="number"
                          name="shiftDeduction"
                          value={shiftData.shiftDeduction || ""}
                          onChange={handleChange}
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>

                      <div className="form-group">
                        <label>Remarks</label>
                        <input
                          type="text"
                          name="Remarks"
                          value={shiftData.Remarks || ""}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Departments</label>
                      <Select
                        isMulti
                        name="DepartmentId"
                        options={departementOption}
                        value={departementOption.filter((opt) =>
                          shiftData.DepartmentId?.includes(opt.value)
                        )}
                        onChange={handleMultiSelectChange}
                        placeholder="Select Departments..."
                      />
                    </div>
                  </div>
                ) : (
                  /* ─────────────────────────────────────────────── */
                  /* NORMAL SHIFTS — full fields */
                  /* ─────────────────────────────────────────────── */
                  <div className="space-y-8">

                    {/* Start & End Time */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="form-group">
                        <label>Start Time <span className="text-red-500">*</span></label>
                        <input
                          type="time"
                          name="StartTime"
                          value={shiftData.StartTime || ""}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>End Time <span className="text-red-500">*</span></label>
                        <input
                          type="time"
                          name="EndTime"
                          value={shiftData.EndTime || ""}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    {/* Working Hours (auto-calculated) */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <div className="form-group">
                        <label>Working Hour (auto)</label>
                        <input
                          type="text"
                          name="WorkingHour"
                          value={shiftData.WorkingHour || ""}
                          readOnly
                          className="bg-gray-800/50"
                        />
                      </div>
                      <div className="form-group">
                        <label>Min Working Hour <span className="text-red-500">*</span></label>
                        <input
                          type="text"
                          name="MinWorkingHour"
                          placeholder="HH:MM"
                          value={shiftData.MinWorkingHour || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          style={{ borderColor: shiftData.MinWorkingHourError ? "red" : "" }}
                        />
                        {shiftData.MinWorkingHourError && (
                          <p className="text-red-500 text-sm mt-1">{shiftData.MinWorkingHourError}</p>
                        )}
                      </div>
                      <div className="form-group">
                        <label>Max Working Hour <span className="text-red-500">*</span></label>
                        <input
                          type="text"
                          name="MaxWorkingHour"
                          placeholder="HH:MM"
                          value={shiftData.MaxWorkingHour || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          style={{ borderColor: shiftData.MaxWorkingHourError ? "red" : "" }}
                        />
                        {shiftData.MaxWorkingHourError && (
                          <p className="text-red-500 text-sm mt-1">{shiftData.MaxWorkingHourError}</p>
                        )}
                      </div>
                    </div>

                    {/* Grace, Allowance, Deduction */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <div className="form-group">
                        <label>Grace Period (minutes)</label>
                        <input
                          type="number"
                          name="GracePeriod"
                          value={shiftData.GracePeriod || ""}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <label>Shift Allowance</label>
                        <input
                          type="number"
                          name="shiftallownace"
                          value={shiftData.shiftallownace || ""}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <label>Shift Deduction</label>
                        <input
                          type="number"
                          name="shiftDeduction"
                          value={shiftData.shiftDeduction || ""}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    {/* Remarks + Half Day Checkbox */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-end">
                      <div className="form-group">
                        <label>Remarks</label>
                        <input
                          type="text"
                          name="Remarks"
                          value={shiftData.Remarks || ""}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="flex items-center gap-3 pb-3">
                        <input
                          hidden
                          type="checkbox"
                          id="allowHalfday"
                          name="allowHalfday"
                          checked={shiftData.allowHalfday === true}
                          onChange={handleChange}
                          disabled
                          className="w-[30px] h-[30px]"
                        />
                        <label hidden htmlFor="allowHalfday" className="cursor-pointer">
                          Allow Half Day
                        </label>
                      </div>
                    </div>

                    {/* ───────────── Half Day Fields ───────────── */}
                    {shiftData.allowHalfday && (
                      <div className="border-t border-gray-700 pt-6 space-y-8">
                        <h6 className="text-lg font-medium">Half Day Configuration</h6>

                        {/* Morning Half Day */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <div className="form-group">
                            <label>Morning Half – Start Time *</label>
                            <input
                              type="time"
                              name="HalfDayStartTimeMorning"
                              value={shiftData.HalfDayStartTimeMorning || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="form-group">
                            <label>Morning Half – End Time *</label>
                            <input
                              type="time"
                              name="HalfDayEndTimeMorning"
                              value={shiftData.HalfDayEndTimeMorning || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <div className="form-group">
                            <label>Morning Working Hours </label>
                            <input
                              type="text"
                              name="WorkingHourMorningHalfDay"
                              placeholder="HH:MM"
                              value={shiftData.WorkingHourMorningHalfDay || ""}
                              onChange={handleChange}
                            />
                          </div>

                          {/* Evening Half Day */}
                          <div className="form-group">
                            <label>Evening Half – Start Time *</label>
                            <input
                              type="time"
                              name="HalfDayStartTimeEvening"
                              value={shiftData.HalfDayStartTimeEvening || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <div className="form-group">
                            <label>Evening Half – End Time *</label>
                            <input
                              type="time"
                              name="HalfDayEndTimeEvening"
                              value={shiftData.HalfDayEndTimeEvening || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="form-group">
                            <label>Evening Working Hours (auto or manual)</label>
                            <input
                              type="text"
                              name="WorkingHourEveningHalfDay"
                              placeholder="HH:MM"
                              value={shiftData.WorkingHourEveningHalfDay || ""}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Departments – always at bottom */}
                    <div className="form-group pt-4 border-t border-gray-700">
                      <label>Departments</label>
                      <Select
                        isMulti
                        name="DepartmentId"
                        options={departementOption}
                        value={departementOption.filter((opt) =>
                          shiftData.DepartmentId?.includes(opt.value)
                        )}
                        onChange={handleMultiSelectChange}
                        placeholder="Select one or more departments..."
                      />
                    </div>
                  </div>
                )}
              </div>

              <div className="px-4 md:px-10 py-6 flex justify-end gap-4 border-t border-border mt-auto">
                <button type="button" onClick={clearData} className="btn btn-outline-secondary">
                  Clear
                </button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? "Saving..." : "Save"}
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
      {/* ===============================================edit-====================================== */}

      {editShiftModal && (
        <form onSubmit={handleEdit}>
          <div className="fixed inset-0 flex items-center justify-center z-[60] bg-black/30 backdrop-blur-sm">
            <div className="w-full max-w-[700px] z-40 bg-black/40 backdrop-blur-sm  bg-bg-dark rounded-lg shadow-light p-6 md:p-10 flex flex-col max-h-[92vh] overflow-hidden">

              {/* Header */}
              <h5 className="relative text-[18px] font-medium text-center border-b border-border pb-4 mb-6">
                Edit Shift
                <button
                  type="button"
                  onClick={() => setEditShiftModal(false)}
                  className="absolute top-0 right-0 text-gray-400 hover:text-white text-2xl px-4 py-2"
                >
                  ×
                </button>
              </h5>

              <div className="flex-1 overflow-y-auto px-2 md:px-8 py-6 space-y-8">

                {/* Always visible: Name + Type */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="form-group flex flex-col gap-2">
                    <label className="font-medium">
                      Shift Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="Name"
                      value={shiftData.Name || ""}
                      onChange={handleChange}
                      required
                      className="bg-gray-800 border border-gray-600 rounded px-3 py-2 focus:outline-none focus:border-sky-500"
                    />
                  </div>

                  <div className="form-group flex flex-col gap-2">
                    <label className="font-medium">
                      Shift Type <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="typeofshift"
                      value={shiftData.typeofshift || ""}
                      onChange={handleChange}
                      required
                      className="bg-gray-800 border border-gray-600 rounded px-3 py-2 focus:outline-none focus:border-sky-500"
                    >
                      <option value="">Select shift type</option>
                      {shifttype?.map((g) => (
                        <option key={g.Id} value={g.Id}>
                          {g.TypeName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* ─────────────────────────────────────────────── */}
                {/*          LONG / UNLIMITED SHIFT CASE             */}
                {/* ─────────────────────────────────────────────── */}
                {isLongDayShift ? (
                  <div className="space-y-8 pt-6 border-t border-gray-700">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <div className="form-group flex flex-col gap-2">
                        <label className="font-medium">Shift Allowance</label>
                        <input
                          type="number"
                          name="shiftallownace"
                          value={shiftData.shiftallownace || ""}
                          onChange={handleChange}
                          onWheel={(e) => e.target.blur()}
                          className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                        />
                      </div>

                      <div className="form-group flex flex-col gap-2">
                        <label className="font-medium">Shift Deduction</label>
                        <input
                          type="number"
                          name="shiftDeduction"
                          value={shiftData.shiftDeduction || ""}
                          onChange={handleChange}
                          onWheel={(e) => e.target.blur()}
                          className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                        />
                      </div>

                      <div className="form-group flex flex-col gap-2">
                        <label className="font-medium">Remarks</label>
                        <input
                          type="text"
                          name="Remarks"
                          value={shiftData.Remarks || ""}
                          onChange={handleChange}
                          className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                        />
                      </div>
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label className="font-medium">Departments</label>
                      <Select
                        isMulti
                        name="DepartmentId"
                        options={departementOption}
                        value={departementOption.filter((opt) =>
                          shiftData.DepartmentId?.includes(opt.value)
                        )}
                        onChange={handleMultiSelectChange}
                        className="text-black"
                        classNamePrefix="react-select"
                        placeholder="Select departments..."
                      />
                    </div>
                  </div>
                ) : (
                  /* ─────────────────────────────────────────────── */
                  /*               NORMAL SHIFT CASE                 */
                  /* ─────────────────────────────────────────────── */
                  <div className="space-y-8">

                    {/* Start & End Time */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="form-group flex flex-col gap-2">
                        <label className="font-medium">
                          Start Time <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="time"
                          name="StartTime"
                          value={shiftData.StartTime || ""}
                          onChange={handleChange}
                          required
                          className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                        />
                      </div>
                      <div className="form-group flex flex-col gap-2">
                        <label className="font-medium">
                          End Time <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="time"
                          name="EndTime"
                          value={shiftData.EndTime || ""}
                          onChange={handleChange}
                          required
                          className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                        />
                      </div>
                    </div>

                    {/* Working Hours row */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <div className="form-group flex flex-col gap-2">
                        <label className="font-medium">Working Hour (auto)</label>
                        <input
                          type="text"
                          value={shiftData.WorkingHour || ""}
                          readOnly
                          className="bg-gray-700/60 border border-gray-600 rounded px-3 py-2 text-gray-300"
                        />
                      </div>

                      <div className="form-group flex flex-col gap-2">
                        <label className="font-medium">
                          Min Working Hour <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="MinWorkingHour"
                          placeholder="HH:MM"
                          value={shiftData.MinWorkingHour || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className="bg-gray-800 border rounded px-3 py-2"
                          style={{ borderColor: shiftData.MinWorkingHourError ? "red" : "" }}
                        />
                        {shiftData.MinWorkingHourError && (
                          <p className="text-red-500 text-xs mt-1">{shiftData.MinWorkingHourError}</p>
                        )}
                      </div>

                      <div className="form-group flex flex-col gap-2">
                        <label className="font-medium">
                          Max Working Hour <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="MaxWorkingHour"
                          placeholder="HH:MM"
                          value={shiftData.MaxWorkingHour || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className="bg-gray-800 border rounded px-3 py-2"
                          style={{ borderColor: shiftData.MaxWorkingHourError ? "red" : "" }}
                        />
                        {shiftData.MaxWorkingHourError && (
                          <p className="text-red-500 text-xs mt-1">{shiftData.MaxWorkingHourError}</p>
                        )}
                      </div>
                    </div>

                    {/* Grace + Allowance + Deduction */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <div className="form-group flex flex-col gap-2">
                        <label className="font-medium">Grace Period (minutes)</label>
                        <input
                          type="number"
                          name="GracePeriod"
                          value={shiftData.GracePeriod || ""}
                          onChange={handleChange}
                          className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                        />
                      </div>
                      <div className="form-group flex flex-col gap-2">
                        <label className="font-medium">Shift Allowance</label>
                        <input
                          type="number"
                          name="shiftallownace"
                          value={shiftData.shiftallownace || ""}
                          onChange={handleChange}
                          className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                        />
                      </div>
                      <div className="form-group flex flex-col gap-2">
                        <label className="font-medium">Shift Deduction</label>
                        <input
                          type="number"
                          name="shiftDeduction"
                          value={shiftData.shiftDeduction || ""}
                          onChange={handleChange}
                          className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                        />
                      </div>
                    </div>

                    {/* Remarks + Half-day toggle */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-end">
                      <div className="form-group flex flex-col gap-2">
                        <label className="font-medium">Remarks</label>
                        <input
                          type="text"
                          name="Remarks"
                          value={shiftData.Remarks || ""}
                          onChange={handleChange}
                          className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                        />
                      </div>

                      <div className="flex items-center gap-3 pb-2">
                        <input
                          type="checkbox"
                          id="allowHalfdayEdit"
                          name="allowHalfday"
                          checked={shiftData.allowHalfday === true}
                          onChange={handleChange}
                          className="w-[30px] h-[30px] accent-sky-500"
                        />
                        <label htmlFor="allowHalfdayEdit" className="cursor-pointer select-none">
                          Allow Half Day
                        </label>
                      </div>
                    </div>

                    {/* ───────────── Half Day Configuration ───────────── */}
                    {shiftData.allowHalfday && (
                      <div className="border-t border-gray-700 pt-8 space-y-8">
                        <h6 className="text-lg font-medium text-sky-400">Half Day Configuration</h6>

                        {/* Morning Half Day */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <div className="form-group flex flex-col gap-2">
                            <label>Morning Half – Start Time *</label>
                            <input
                              type="time"
                              name="HalfDayStartTimeMorning"
                              value={shiftData.HalfDayStartTimeMorning || ""}
                              onChange={handleChange}
                              required
                              className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                            />
                          </div>
                          <div className="form-group flex flex-col gap-2">
                            <label>Morning Half – End Time *</label>
                            <input
                              type="time"
                              name="HalfDayEndTimeMorning"
                              value={shiftData.HalfDayEndTimeMorning || ""}
                              onChange={handleChange}
                              required
                              className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <div className="form-group flex flex-col gap-2">
                            <label>Morning Half – Working Hours</label>
                            <input
                              type="text"
                              name="WorkingHourMorningHalfDay"
                              placeholder="HH:MM"
                              value={shiftData.WorkingHourMorningHalfDay || ""}
                              onChange={handleChange}
                              className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                            />
                          </div>

                          <div className="form-group flex flex-col gap-2">
                            <label>Evening Half – Start Time *</label>
                            <input
                              type="time"
                              name="HalfDayStartTimeEvening"
                              value={shiftData.HalfDayStartTimeEvening || ""}
                              onChange={handleChange}
                              required
                              className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <div className="form-group flex flex-col gap-2">
                            <label>Evening Half – End Time *</label>
                            <input
                              type="time"
                              name="HalfDayEndTimeEvening"
                              value={shiftData.HalfDayEndTimeEvening || ""}
                              onChange={handleChange}
                              required
                              className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                            />
                          </div>

                          <div className="form-group flex flex-col gap-2">
                            <label>Evening Half – Working Hours</label>
                            <input
                              type="text"
                              name="WorkingHourEveningHalfDay"
                              placeholder="HH:MM"
                              value={shiftData.WorkingHourEveningHalfDay || ""}
                              onChange={handleChange}
                              className="bg-gray-800 border border-gray-600 rounded px-3 py-2"
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Departments – bottom of normal shift */}
                    <div className="form-group flex flex-col gap-2 pt-4 border-t border-gray-700">
                      <label className="font-medium">Departments</label>
                      <Select
                        isMulti
                        name="DepartmentId"
                        options={departementOption}
                        value={departementOption.filter((opt) =>
                          shiftData.DepartmentId?.includes(opt.value)
                        )}
                        onChange={handleMultiSelectChange}
                        className="text-black"
                        classNamePrefix="react-select"
                        placeholder="Select one or more departments..."
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* Footer buttons */}
              <div className="px-4 md:px-10 py-6 flex justify-end gap-4 border-t border-border mt-4">
                <button
                  type="button"
                  onClick={clearDataForEdit}
                   className="btn btn-outline-secondary"
                >
                  Clear
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-8 py-2 bg-sky-600 hover:bg-sky-500 rounded transition disabled:opacity-50"
                >
                  {loading ? "Saving..." : "Update Shift"}
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
}
